/**
 * Reading values out of the router's already-parsed search params.
 */

/**
 * A search value as text, or `undefined` when it's neither a string nor a
 * number.
 *
 * The router's search parser runs every value through `JSON.parse`, so
 * `?key=12345` arrives as a number and a bare `typeof value === 'string'` test
 * would drop it. The callers read opaque tokens, which can occasionally be all
 * digits.
 */
export function asText(value: unknown): string | undefined {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return undefined;
}
